import React, { Component } from 'react';

import _ from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import history from 'config/history';
import ReCAPTCHA from 'react-google-recaptcha';
import WithVendorCount from 'shared/HOCs/WithVendorCount';

import Button from 'shared/components/Button';
import LinkedInButton from 'shared/components/LinkedInButton';
import renderInputField from 'shared/forms/RenderInputField';
import { openModal, selectModal } from 'shared/components/Modals/reducer';
import { strongPassword, required } from 'shared/forms/validators';
import { validateCredentials } from 'shared/components/Signup/ducks';
import renderCheckbox from 'shared/forms/RenderCheckbox';
import ExternalLink from 'shared/components/ExternalLink';
import { MODALS, TERMS_AND_CONDITIONS, PRIVACY_POLICY } from 'global-constants';

import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

import { SIGNUP_HELP_TEXTS } from './constants';
import { asyncValidate } from './asyncValidate';

import { getHelpTextKey } from './utils';

import styles from './styles.module.scss';

const CREDENTIALS_FORM_NAME = 'registerForm';

class CredentialsForm extends Component {
  state = {
    privacyPolicy: false,
    termsOfService: false,
    ReCAPTCHA: false
  };
  submit = values => {
    this.props.validateCredentials(values, CREDENTIALS_FORM_NAME);
  };

  handlePrivacyCheckboxClick = () => {
    this.setState({
      privacyPolicy: !this.state.privacyPolicy
    });
  };

  handleTOSCheckboxClick = () => {
    this.setState({
      termsOfService: !this.state.termsOfService
    });
  };
  handleRecaptcha = () => {
    this.setState({
      ReCAPTCHA: !this.state.ReCAPTCHA
    });
  };

  redirectToLogin = () => {
    this.props.closeModal();
    this.props.openModal({ modalName: MODALS.LOGIN });
  };

  render() {
    const { handleSubmit, submitting, invalid, modalData } = this.props;

    const nextUrl = buildUrlFromNextRedirect(history.location.search);

    const helpTextKey = getHelpTextKey(nextUrl);

    let helpTextData = SIGNUP_HELP_TEXTS[helpTextKey];

    if (_.isEmpty(helpTextData) && !_.isEmpty(modalData)) {
      helpTextData = modalData;
    }

    return (
      <div className={styles.registerFormWrapper}>
        <div className={classnames(styles.companyIntroWrapper, 'remove-sm')}>
          <div>
            <div className={styles.companyInfoHeading}>
              {helpTextData
                ? helpTextData.textOnLeft
                : "Your free account will help connect you with the people leading real estate's transformation, around the world."}
            </div>
            <ul className={styles.companyBullets}>
              {helpTextData && helpTextData.bullets ? (
                helpTextData.bullets.map(bullet => <li>{bullet}</li>)
              ) : (
                <>
                  <li>
                    Watch and participate in our unique global events platform
                    for real estate professionals
                  </li>
                  <li>
                    Research over {this.props.vendorCount} global technology
                    vendors
                  </li>
                  <li>
                    Our unique data helps you make smarter decisions, faster
                  </li>
                  <li>
                    Connect, network with and message the influencers leading
                    the transformation of real estate
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
        <div className={styles.registerFormInnerWrapper}>
          <div className={styles.registerFormContainer}>
            <div className={classnames(styles.title, 'remove-sm')}>
              {helpTextData ? helpTextData.textOnRight : 'Sign up for free.'}
            </div>
            <div className={classnames(styles.title, 'remove-md-min')}>
              Your free account will help connect you with the people leading
              real estate's transformation, around the world.
            </div>
            <LinkedInButton name="Sign up with LinkedIn" />
            <div className={styles.divider}>
              <div className={styles.orBox}>or</div>
            </div>
            <form
              className={classnames(styles.form, 'form')}
              onSubmit={handleSubmit(this.submit)}>
              <div className="form-group">
                <input
                  style={{ display: 'none' }}
                  type="password"
                  name="password"
                />
                <label className="form-label">Email address</label>
                <Field
                  name="email"
                  component={renderInputField}
                  type="email"
                  validate={required}
                  placeholder="Enter your email address"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Create a Password</label>
                <Field
                  name="password"
                  component={renderInputField}
                  type="password"
                  placeholder="8 characters or more"
                  disabled={submitting}
                  validate={strongPassword}
                />
              </div>
              <div className={styles.checkBoxRow}>
                <Field
                  name="privacy_accepted"
                  component={renderCheckbox}
                  onChange={this.handlePrivacyCheckboxClick}
                />
                <div className={styles.label}>
                  I agree to allow Unissu to collect, store and process my data,
                  as per the{' '}
                  <ExternalLink
                    href={PRIVACY_POLICY}
                    children="Privacy Policy"
                  />
                </div>
              </div>
              <div className={styles.checkBoxRow}>
                <Field
                  name="terms_of_service_accepted"
                  component={renderCheckbox}
                  onChange={this.handleTOSCheckboxClick}
                />
                <div className={styles.label}>
                  I have read and agree to the{' '}
                  <ExternalLink
                    href={TERMS_AND_CONDITIONS}
                    children="Terms of Service"
                  />
                </div>
              </div>
              <Button
                id={helpTextData ? helpTextData.btnId : 'generic-signup-button'}
                className={styles.signupBtn}
                color="brand-green"
                type="submit"
                disabled={
                  invalid ||
                  submitting ||
                  !this.state.privacyPolicy ||
                  !this.state.termsOfService
                }>
                Sign up
              </Button>

              <p className={styles.loginText}>
                Already signed up?{' '}
                <span className={styles.link} onClick={this.redirectToLogin}>
                  Log in
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

CredentialsForm = reduxForm({
  form: CREDENTIALS_FORM_NAME,
  destroyOnUnmount: false,
  asyncValidate,
  asyncBlurFields: ['email', 'password']
})(CredentialsForm);

const mapStateToProps = state => {
  const { data } = selectModal(state, MODALS.SIGNUP);

  return {
    modalData: data
  };
};

const mapDispatchToProps = {
  validateCredentials,
  openModal
};

export default WithVendorCount(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CredentialsForm)
);
